import React from 'react';
import classNames from 'classnames';

import { BadgeType } from '@wix/members-badge-lib';

import styles from './member-search-badge.scss';
import { XIcon } from '../icons/x-icon';
import { ICON_SIZE } from '../../constants/icon-sizes';
import { Button } from '../button';

interface Props {
  badge: BadgeType;
  handleClose: () => void;
}

export const MemberSearchBadge: React.StatelessComponent<Props> = ({ badge, handleClose }) => (
  <div
    className={classNames([styles.container, 'ma-all-members-search-badge-bg'])}
    data-hook="ma-all-members-search-input-badge"
  >
    <div className={classNames([styles.badge, 'ma-all-members-header-text-color'])}>{badge.title}</div>
    <Button onClick={() => handleClose()} className={styles.button}>
      <XIcon size={ICON_SIZE.XSMALL} className={classNames([styles.icon, 'ma-all-members-search-badge-icon-stroke'])} />
    </Button>
  </div>
);
